'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$ImportRecipesAppPage(queryParams) {
  this.Sb = null;
  this.Sb = queryParams;
}
export { $c_Lmealorama_AppRouter$ImportRecipesAppPage as $c_Lmealorama_AppRouter$ImportRecipesAppPage };
$p = $c_Lmealorama_AppRouter$ImportRecipesAppPage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$ImportRecipesAppPage;
/** @constructor */
function $h_Lmealorama_AppRouter$ImportRecipesAppPage() {
}
export { $h_Lmealorama_AppRouter$ImportRecipesAppPage as $h_Lmealorama_AppRouter$ImportRecipesAppPage };
$h_Lmealorama_AppRouter$ImportRecipesAppPage.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-877202312), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_AppRouter$ImportRecipesAppPage)) {
    var x = this.Sb;
    var x$2 = x$0.Sb;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "ImportRecipesAppPage";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.Sb;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_AppRouter$ImportRecipesAppPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ji)));
}
export { $isArrayOf_Lmealorama_AppRouter$ImportRecipesAppPage as $isArrayOf_Lmealorama_AppRouter$ImportRecipesAppPage };
var $d_Lmealorama_AppRouter$ImportRecipesAppPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$ImportRecipesAppPage, "mealorama.AppRouter$ImportRecipesAppPage", ({
  ji: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_AppRouter$ImportRecipesAppPage as $d_Lmealorama_AppRouter$ImportRecipesAppPage };
//# sourceMappingURL=mealorama.-App-Router$-Import-Recipes-App-Page.js.map
